import get from 'lodash/get';
import { models, utils } from '@kurtosys/ksys-app-template';
import { DataStore, GlobalDisclaimerStore } from '../stores';
import { Stores } from '../models/Stores';
import { DisclaimerElement } from '../models/configuration/DisclaimerElement';
import {
    IExecutionOptions,
    IQueryContext,
} from '@kurtosys/ksys-app-template/dist/models/query';
import { transformValue } from './transform/transform';

export function getDisclaimers(
    dataStore: DataStore,
    disclaimerTypes: Array<DisclaimerElement> = [],
    entityDisclaimers: any,
    queryContext: IQueryContext
) {
    const disclaimers = disclaimerTypes
        .map(disclaimer => {
            return getDisclaimer(
                dataStore,
                disclaimer,
                entityDisclaimers,
                queryContext
            );
        })
        .filter(d => d !== undefined);

    return disclaimers;
}

export function getDisclaimer(
    dataStore: DataStore,
    disclaimer: DisclaimerElement,
    entityDisclaimers: any,
    queryContext: IQueryContext
) {
    let rawValue;
    if (disclaimer.linked) {
        const disclaimerDictionary = getDisclaimersDictionary(
            entityDisclaimers,
            dataStore.culture,
            dataStore.config.defaultCulture
        );
        rawValue = get(disclaimerDictionary, disclaimer.disclaimerType);
    } else {
        rawValue = GlobalDisclaimerStore.get(disclaimer.disclaimerType);
    }
    if (disclaimer.transforms) {
        const { stores } = dataStore;
        const { query: queryStore } = stores;
        const executionOptions: IExecutionOptions = queryStore.getExecutionOptionsUsingContext(
            queryContext
        );

        rawValue = transformValue(
            rawValue,
            disclaimer.transforms,
            dataStore.stores.translation,
            executionOptions
        );
    }

    return rawValue;
}

function getDisclaimersDictionary(
    disclaimers: any,
    culture: string,
    defaultCulture: string
) {
    const disclaimersDictionary = {};

    for (const d in disclaimers) {
        if (disclaimers[d]) {
            const { disclaimer = '' } =
                disclaimers[d].find(dc => dc.culture === culture) ||
                disclaimers[d].find(dc => dc.culture === defaultCulture) ||
                {};
            disclaimersDictionary[d] = disclaimer;
        }
    }

    return disclaimersDictionary;
}

export function getCulturedDisclaimerFromResponse(
    sharedStores: Stores,
    disclaimers: Array<models.api.common.TDisclaimerItem>
) {
    if (
        utils.isArrayLike.isArrayLike(disclaimers) &&
        disclaimers.length > 0 &&
        sharedStores.data
    ) {
        const dataStore = sharedStores.data;
        if (dataStore.config) {
            const config = dataStore.config;
            const targetCultureDisclaimer =
                dataStore.culture &&
                disclaimers.find(
                    disclaimer => disclaimer.culture === dataStore.culture
                );
            const defaultCultureDisclaimer =
                config.defaultCulture &&
                disclaimers.find(
                    disclaimer => disclaimer.culture === config.defaultCulture
                );
            const culturedDisclaimer =
                targetCultureDisclaimer || defaultCultureDisclaimer;
            return culturedDisclaimer && culturedDisclaimer.disclaimer;
        }
    }
    return;
}



// WEBPACK FOOTER //
// ./src/utils/disclaimers.ts